// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"78":"28159a25","506":"2af12138","627":"70fdec75","780":"c066c0de","879":"80107b31"}[chunkId] + ".css";
};